export const SWIPE_EDGE_PX = 24;
export const SWIPE_TRIGGER_PX = 64;
export const PULL_TRIGGER_PX = 72;

export type SwipeBackDecision = "ignore" | "dismiss-overlay" | "back";

/** React Router stores the stack index on `history.state.idx`. */
export function historyCanGoBack(state: unknown): boolean {
  if (!state || typeof state !== "object") return false;
  const idx = (state as { idx?: unknown }).idx;
  return typeof idx === "number" && idx > 0;
}

/**
 * Left-edge swipe to the right.
 * An open dialog closes first. Otherwise pop history. Never exits the app.
 */
export function decideSwipeBack(input: {
  startX: number;
  dx: number;
  dy: number;
  overlayOpen: boolean;
  canGoBack: boolean;
}): SwipeBackDecision {
  if (input.startX > SWIPE_EDGE_PX) return "ignore";
  if (input.dx < SWIPE_TRIGGER_PX) return "ignore";
  if (Math.abs(input.dy) > input.dx) return "ignore";
  if (input.overlayOpen) return "dismiss-overlay";
  if (input.canGoBack) return "back";
  return "ignore";
}

/** Pull down from the top of the scroll, away from the back-edge. */
export function decidePullRefresh(input: {
  startX: number;
  dx: number;
  dy: number;
  atTop: boolean;
  overlayOpen: boolean;
}): boolean {
  if (input.overlayOpen || !input.atTop) return false;
  if (input.startX <= SWIPE_EDGE_PX) return false;
  if (input.dy < PULL_TRIGGER_PX) return false;
  if (Math.abs(input.dx) > input.dy) return false;
  return true;
}
